export const comingSourceType = {
  CREATE_CAMPAIGN: 1,
  CREATE_AD_GROUP: 2,
  CREATE_AD: 3,
  COPY_CAMPAIGN: 4,
  COPY_AD_GROUP_TO_NEW_CAMPAIGN: 5,
  COPY_AD_GROUP_TO_EXISTED_CAMPAIGN: 6,
  COPY_AD_TO_NEW_CAMPAIGN_AD_GROUP: 7,
  COPY_AD_TO_EXISTED_CAMPAIGN_AD_GROUP: 8,
  COPY_AD_TO_EXISTED_CAMPAIGN_NEW_AD_GROUP: 9,
  BRAND_AD_BULK_COPY: 100,
};
